import { useCallback, useState } from 'react'
import { showKiMarker } from '../lib/kiMarker'

export interface UseKiMarkerResult {
  showKi: boolean
  confirm: () => void
  reset: (origin: string) => void
}

export function useKiMarker(kiErzeugt: boolean, value: string): UseKiMarkerResult {
  const [origin, setOrigin] = useState('')
  const [confirmed, setConfirmed] = useState(false)

  const showKi = showKiMarker({ ki_erzeugt: kiErzeugt, origin }, value, confirmed)

  const confirm = useCallback(() => setConfirmed(true), [])
  const reset = useCallback((newOrigin: string) => {
    setOrigin(newOrigin)
    setConfirmed(false)
  }, [])

  return { showKi, confirm, reset }
}
